import { Alert } from "plos/src/components/alerts";
import { useTranslation } from "react-i18next";

interface ErrorAlertProps {
  errorCode: string;
}

const ErrorAlert = ({ errorCode }: ErrorAlertProps) => {
  const { t } = useTranslation("transfers");
  if (!errorCode) return null;

  return (
    <Alert variant="error" isLiveRegion>
      {errorCode === "transfer_cap_exceeded" &&
        t(
          "confirmTransfers.alert.transferCapExceeded",
          "Unable to confirm transfers as they will take you over the limit of 20 transfers in a single Gameweek.",
        )}
      {(errorCode === "transfer_element_in_price_mismatch" ||
        errorCode === "transfer_element_out_price_mismatch") &&
        t(
          "confirmTransfers.alert.transferPriceMismatch",
          "Unable to confirm transfers as player prices have changed. Please refresh the page and try again.",
        )}
    </Alert>
  );
};

export default ErrorAlert;
